import InquiryApi from '@apis/inquiry/InquiryApi';
import inquiryQueries from '@apis/queries/inquiryQueries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { InquiryCommentRequest } from '@models/inquiry';
import { useFlow } from '@stackflow/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useCommentInquiry(inquiryId: string) {
    const { t } = useTranslation('inquiry');
    const toast = useToast();
    const queryClient = useQueryClient();
    const { pop } = useFlow();
    const { mutate } = useMutation({
        mutationFn: (request: InquiryCommentRequest) => InquiryApi.createComment(
            inquiryId,
            request,
        ),
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: inquiryQueries._def });
            toast.success(t('comment.success'));
            pop(2);
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('comment.error'));
        },
    });
    return (content: string, fileUrls: string[]) => {
        mutate({ content, fileUrls });
    };
}

export default useCommentInquiry;
